import store from "../store/index";
import {
  PLANNER_ENDPOINT,
  PLANNER_TASK_ENDPOINT,
  ADAPT_PLANNER_ENDPOINT
} from "../constants/urls";
import ApiHelpers from "../helpers/ApiHelpers";

export const plannerService = {
  createPlanner,
  getPlanners,
  getPlannerById,
  updatePlanner,
  deletePlanner,
  createPlannerTask,
  updatePlannerTask,
  deletePlannerTask,
  getPlannerTasks,
  adaptPlanner,
  createPlannerTaskAssociations,
  deletePlannerTaskAssociations
};

// Planner Operations

async function createPlanner(plannerObj) {
  try {
    let requestBody = JSON.stringify(plannerObj);
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT,
      "POST",
      requestBody,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function getPlanners(productVariantID) {
  let QUERY = '?';
  if (productVariantID) {
    QUERY += `productVariantID=${productVariantID}`;
  }
  try {
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT + QUERY,
      "GET",
      null,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function getPlannerById(plannerId) {
  try {
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT + `/${plannerId}`,
      "GET",
      null,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function updatePlanner(plannerObj) {
  try {
    let requestBody = JSON.stringify(plannerObj);
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT,
      "PUT",
      requestBody,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function deletePlanner(plannerId) {
  try {
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT + `/${plannerId}`,
      "DELETE",
      null,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

// Planner Task Operations

async function createPlannerTask(plannerTaskObj) {
  try {
    let requestBody = JSON.stringify(plannerTaskObj);
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_TASK_ENDPOINT,
      "POST",
      requestBody,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function updatePlannerTask(plannerTaskObj) {
  try {
    let requestBody = JSON.stringify(plannerTaskObj);
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_TASK_ENDPOINT,
      "PUT",
      requestBody,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function deletePlannerTask(plannerTaskId) {
  try {
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_TASK_ENDPOINT + `/${plannerTaskId}`,
      "DELETE",
      null,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function getPlannerTasks(plannerId) {
  try {
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT + `/${plannerId}`+ '/tasks',
      "GET",
      null,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

// Planner Adaptation

async function adaptPlanner(adaptPlannerObj) {
  try {
    let requestBody = JSON.stringify(adaptPlannerObj);
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + ADAPT_PLANNER_ENDPOINT,
      "POST",
      requestBody,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

// Planner Task Association Operations

async function createPlannerTaskAssociations(plannerTaskId, associations) {
  try {
    let requestBody = JSON.stringify(associations);
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT + `tasks/${plannerTaskId}/associations`,
      "POST",
      requestBody,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

async function deletePlannerTaskAssociations(plannerTaskId, associationIds) {
  try {
    const queryString = associationIds.map(id => `ids=${id}`).join('&');
    let body = await ApiHelpers.makeAPICall(
      store.state.appState.apiURL + PLANNER_ENDPOINT + `/${plannerTaskId}/associations?${queryString}`,
      "DELETE",
      null,
      false
    );
    return handleResponse(await body?.json());
  } finally {}
}

function handleResponse(body) {
    if (body?.status?.toLowerCase() === 'success') {
      return body.payload; 
    } else {
      return null; 
    }
  }
